import React from 'react';
import TabPanel from '../../components/TabPanel';
import Grid from '@mui/material/Grid';
import { JobGroup, Group } from '../../types/group';
import JobGroupSelect from './JobGroupSelect';
import JobGroups from './JobGroups';
import useConfigStyles from '../../components/useConfigStyles';

interface JobGroupsTabPanelProps {
  groups: Group[];
  index: number;
  selectedTab: number;
  editable: boolean;
  onGroupsUpdate?: (groups: Group[]) => void;
}

function JobGroupsTabPanel({ groups, index, selectedTab, editable, onGroupsUpdate }: JobGroupsTabPanelProps): JSX.Element {
  const classes = useConfigStyles();

  const addGroup = (group: JobGroup) => {
    if (!onGroupsUpdate) {
      return;
    }
    const updatedGroups = groups;
    const groupIndex = groups.findIndex((v) => v.Name === group.Name);
    if (groupIndex >= 0) {
      updatedGroups[groupIndex].Severity = group.Severity;
      updatedGroups[groupIndex].Disabled = group.Disabled;
      onGroupsUpdate(updatedGroups);
    } else {
      onGroupsUpdate(updatedGroups.concat({ ...group, Rules: [] }));
    }
  };

  const removeGroup = (group: Group) => {
    if (!onGroupsUpdate) {
      return;
    }
    const groupIndex = groups.indexOf(group);
    groups.splice(groupIndex, 1);
    onGroupsUpdate(groups);
  };

  return (
    <TabPanel selectedValue={selectedTab} index={index} className={classes.container}>
      {editable && (
        <Grid item className={classes.input} md={6}>
          <JobGroupSelect groups={groups} addGroup={addGroup} />
        </Grid>
      )}
      <Grid item className={classes.input} md={6}>
        <JobGroups groups={groups} removeGroup={removeGroup} editable={editable} />
      </Grid>
    </TabPanel>
  );
}

JobGroupsTabPanel.defaultProps = {
  onGroupsUpdate: () => {},
};

export default JobGroupsTabPanel;
